import type { Locale } from "@/lib/i18n";
import { pl, type WDedicatedJobOffersTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wDedicatedJobOffersTranslations: Record<Locale, WDedicatedJobOffersTranslations> = {
  pl,
  en,
  de,
};

export type { WDedicatedJobOffersTranslations };
